import {Button, Input, Notify, ConnectWalletModal} from '@airdao/ui-library'
import TxHistory from "./components/TxHistory";
import Pagination from "./components/Pagination";
import {useEffect, useState} from "react";
import axios from "axios";
import {ethers, utils} from "ethers";
import {useWeb3React} from "@web3-react/core";
import discord from './assets/icons/discord.svg';
import medium from './assets/icons/medium.svg';
import telegram from './assets/icons/telegram.svg';
import x from './assets/icons/x.svg';
import { useAuthorization} from 'airdao-components-and-tools/hooks';
import { metamaskConnector, walletconnectConnector} from 'airdao-components-and-tools/utils';

function formatNumberWithCommas(number) {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

const readProvider = new ethers.providers.JsonRpcProvider(
  process.env.REACT_APP_RPC_URL,
);

function App() {
  const {provider, account, chainId} = useWeb3React();

  const [isLoginOpen, setIsLoginOpen] = useState(false);
  const [paginationData, setPaginationData] = useState(null);
  const [page, setPage] = useState(1);
  const [amount, setAmount] = useState('');
  const [totalBurned, setTotalBurned] = useState(0);
  const [error, setError] = useState('');

  const { loginMetamask, loginWalletConnect } = useAuthorization(
    metamaskConnector,
    walletconnectConnector,
  );

  useEffect(() => {
    setIsLoginOpen(false);
  }, [account, chainId]);

  useEffect(() => {
    if (readProvider) {
      getTotalBurned()
    }
  }, [readProvider]);

  useEffect(() => {
    getTxs();
  }, [page]);

  const getTotalBurned = () => {
    readProvider.getBalance(ethers.constants.AddressZero)
      .then((res) => setTotalBurned((+utils.formatEther(res)).toFixed(2)));
  };

  const getTxs = () => {
    axios.get(`${process.env.REACT_APP_EXPLORER_URL}/addresses/${ethers.constants.AddressZero}/all?limit=4&page=${page}`)
      .then(({data}) => {
        setPaginationData(data)
      });
  }

  const burn = async () => {
    if (!amount) {
      setError('Enter amount');
      return;
    }
    try {
      Notify.loading('Transaction in progress.',null,  {toastId: "loading"});

      const signer = await provider.getSigner();
      const tx = await signer.sendTransaction({
        to: ethers.constants.AddressZero,
        value: ethers.utils.parseEther(amount),
      });
      await tx.wait();
      Notify.dismiss('loading');
      Notify.success(`Success!`, null, {autoClose: 5000});
      setAmount('');
      getTotalBurned();
    } catch (e) {
      console.log(e);
      Notify.dismiss('loading');
      Notify.error('Error', null, {})
    }
  };

  const handleInput = (e) => {
    setError('');
    if (/^\d+$/.test(e.target.value) || !e.target.value) {
      setAmount(e.target.value);
    }
  };

  const handleLogin = () => {
    setIsLoginOpen(true);
  }

  return (
    <div className="app">
      <div className="content">
        <p className="content__total">TOTAL BURNED TOKENS</p>
        <h1 className="content__total-amb">{formatNumberWithCommas(totalBurned)} AMB</h1>
        <div className="form">
          <span className="form__label">Amount to burn</span>
          <Input
            placeholder="0 AMB"
            value={amount}
            error={error}
            onChange={handleInput}
            pattern="\d*"
          />
          {(account && process.env.REACT_APP_CHAIN_ID === chainId?.toString()) ? (
            <Button size="large" type="secondary" className="form__btn" onClick={burn}>
              Burn
            </Button>
          ) : (
            <Button
              type="secondary"
              size="large"
              className="form__btn"
              onClick={handleLogin}
            >
              Connect wallet
            </Button>
          )}
        </div>
        {paginationData && (
          <>
            <TxHistory txs={paginationData.data}/>
            <Pagination
              onPageChange={setPage}
              currentPage={page}
              totalPages={paginationData.pagination.pageCount}
            />
          </>
        )}
      </div>
      <div className="socials">
        <a href="https://twitter.com/airdao_io">
          <img src={x} alt="x"/>
        </a>
        <a href="https://t.me/AirDAOnews">
          <img src={telegram} alt="telegram"/>
        </a>
        <a href="https://blog.airdao.io/">
          <img src={medium} alt="medium"/>
        </a>
        <a href="https://discord.gg/airdao">
          <img src={discord} alt="discord"/>
        </a>
      </div>
      {isLoginOpen && (
        <ConnectWalletModal
          loginMetamask={loginMetamask}
          loginWalletConnect={loginWalletConnect}
          isOpen={isLoginOpen}
          close={() => setIsLoginOpen(false)}
        />
      )}
    </div>
  );
}

export default App;
